import React from 'react';

function Home() {
  return (
    <div id="home">
      <h1>Bienvenue sur Speeker V2</h1>
    </div>
  );
}

export default Home;